import { axiosPrivate } from "./axios";

const getUbereatsStores = async ({ code, storeId }) => {
  return await axiosPrivate
    .post(
      `/stores-service/stores/${storeId}/ubereats`,
      {
        single_use_authorization_code: code,
        redirect_uri: `${process.env.REACT_APP_UBER_REDIRECT_URI}`,
      },
      {
        headers: {
          client: "INTEGRATOR",
        },
      },
    )
    .then(({ data }) => {
      return {
        accessToken: data?.data?.accessToken,
        stores: data?.data?.stores,
      };
    });
};

const getUberEatsOAuth2Link = async ({
  integratorId,
  storeId,
  redirectUri,
  token
}) => {
  return await axiosPrivate
    .get(
      `/integrator-service/integrators/${integratorId}/stores/${storeId}/onboard-delivery-services/ubereats/generate-oauth`,
      {
        params: {
          redirect_uri: redirectUri,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then(({ data }) => {
      return {
        oauth_link: data?.data?.oauthLink
      };
    });
};

const postExchangeAuthorizationCode = async ({
  integratorId,
  storeId,
  redirectUri,
  authorizationCode,
  token
}) => {
  return await axiosPrivate
    .post(
      `/integrator-service/integrators/${integratorId}/stores/${storeId}/onboard-delivery-services/ubereats/exchange-authorization-code`,
      {
        authorization_code: authorizationCode,
        redirect_uri: redirectUri,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then(({ data }) => data?.data);
};

const postProvisionStore = async ({
  integratorId,
  storeId,
  accessToken,
  uberStoreId,
  token
}) => {
  return await axiosPrivate
    .post(
      `/integrator-service/integrators/${integratorId}/stores/${storeId}/onboard-delivery-services/ubereats/provision-store`,
      {
        access_token: accessToken,
        uber_store_id: uberStoreId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then(({ data }) => data?.data);
};

const postDeprovisionStore = async ({ storeId, token }) => {
  return await axiosPrivate.delete(
    `/stores-service/stores/${storeId}/ubereats/provision`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  ).then(({ data }) => data);
};

const uploadImage = async ({ image }) =>
  await axiosPrivate.put("/v1/image", image, {
    headers: {
      client: "INTEGRATOR",
      Authorization: "Basic YmV2ejIwMjM6QmV2ekAxMjM0NSE=",
    },
  });

export {
  getUbereatsStores as default,
  getUbereatsStores,
  getUberEatsOAuth2Link,
  postExchangeAuthorizationCode,
  postProvisionStore,
  postDeprovisionStore,
  uploadImage,
};
